<div [loading]="loading">	
	<div class="block">
		<div class="ariane-container">
			<gob-ariane [product]="product"></gob-ariane>
		</div>
		<div class="product-container">
			<div class="diapo-container-desk hidden-phone">
				<gob-gallery [product]="product"></gob-gallery>
			</div>
			<gob-product-detail [product]="product"></gob-product-detail>
		</div>

		<div class="details-container">
			<ul class="nav nav-tabs">
			  <li class="nav-item">
			    <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#detail-tab-pane" type="button">Détails</button>
			  </li>
			  <li class="nav-item">
			    <button class="nav-link" data-bs-toggle="tab" data-bs-target="#characteristics-tab-pane" type="button">Caractéristiques</button>
			  </li>
			</ul>
			<div class="tab-content" id="detail-product-container">
			  <div class="tab-pane fade show active" id="detail-tab-pane" [innerHTML]="product?.details"></div>
			  
			  <div *ngIf="product?.marque" class="tab-pane fade" id="characteristics-tab-pane">
				<div>
					<p class="charac">Edition</p>
					<p *ngIf="product?.author">Auteur <b>{{ product?.author }}</b></p>
					<p *ngIf="product?.illustrator">Illustrateur <b>{{ product?.illustrator }}</b></p>
					<p *ngIf="product?.marque">Editeur <b>{{ product?.marque }}</b></p>
				</div>
				<div class="mt-2" *ngIf="product?.weight">
					<p class="charac">Dimensions et poids</p>
					<p *ngIf="product?.weight">Poids <b>{{ product?.weight }} kg</b></p>
					<p *ngIf="product?.length">Longueur <b>{{ product?.length }}</b></p>
					<p *ngIf="product?.height">Hauteur <b>{{ product?.height }}</b></p>
					<p *ngIf="product?.depth">Profondeur <b>{{ product?.depth }}</b></p>
				</div>
			  </div>
			</div>
		</div>

		<div class="reviews-section-container" id="review-section">
			<h2 class="section-title">Avis clients</h2>
			<div id="review-tab-pane"> <div *ngIf="!product.ratings.length" class="rating-container">
					Il n'y a pas encore d'avis pour ce produit, soyez le premier.
				</div>
				<gob-rating *ngFor="let rating of product.ratings" [rating]="rating"></gob-rating>
				
				<div class="footer-review-action">
					<button class="btn-write" data-bs-toggle="modal" data-bs-target="#ratingModal">
						<i class="fa-solid fa-pen-to-square"></i> Laisser un avis
					</button>
				</div>
			</div>
		</div>

		<div class="linked-container">
			<h2>On vous recommande</h2>
			<div class="linked-product">
				<div *ngFor="let p of product.linked" class="product">
					<gob-product-card [product]="p"></gob-product-card>
				</div>
			</div>
		</div>
	</div>
</div>